import { Box, Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { validacionesRecepcionCatalogService } from '../../../api/services'
import type {
  ValidationConfigurationItem,
} from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const SeveridadBadge = ({ severidad }: { severidad: string }) => {
  const color = severidad === 'Rojo' ? '#c8442f' : '#d49a2a'
  return (
    <Box
      display="inline-block"
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="10px"
      fontWeight="700"
      textTransform="uppercase"
      bg={`${color}20`}
      color={color}
    >
      {severidad}
    </Box>
  )
}

const BoolBadge = ({ value }: { value: boolean }) => (
  <Box
    display="inline-block"
    px={2}
    py={0.5}
    borderRadius="md"
    fontSize="10px"
    fontWeight="700"
    bg={value ? 'rgba(42, 138, 135,0.2)' : 'rgba(181, 170, 157,0.2)'}
    color={value ? '#2a8a87' : '#b5aa9d'}
  >
    {value ? 'Sí' : 'No'}
  </Box>
)

const columns: ColumnConfig<ValidationConfigurationItem>[] = [
  { header: 'Código', render: (v) => <Text fontFamily="monospace" fontSize="xs" fontWeight="600" color={themeColors.text}>{v.codigo}</Text> },
  { header: 'Nombre', render: (v) => <Text fontSize="sm" color={themeColors.text}>{v.nombre}</Text> },
  { header: 'Grupo', render: (v) => <Text fontSize="sm" color={themeColors.textSecondary}>{v.grupoNombre}</Text> },
  { header: 'Severidad', render: (v) => <SeveridadBadge severidad={v.severidad} /> },
  { header: 'Fuente', render: (v) => <Text fontSize="xs" color={themeColors.textMuted}>{v.fuente}</Text> },
  { header: 'Activa', render: (v) => <BoolBadge value={v.activa} /> },
  { header: 'PN', render: (v) => <BoolBadge value={v.aplicaPN} /> },
  { header: 'PJ', render: (v) => <BoolBadge value={v.aplicaPJ} /> },
]

const fields: FieldConfig<ValidationConfigurationItem>[] = [
  { name: 'codigo', label: 'Código', type: 'text', required: true, placeholder: 'ej. VAL_001' },
  { name: 'nombre', label: 'Nombre', type: 'text', required: true },
  { name: 'descripcion', label: 'Descripción', type: 'textarea', colSpan: 2 },
  { name: 'grupoNombre', label: 'Grupo', type: 'text', required: true },
  { name: 'grupoIcono', label: 'Icono del grupo', type: 'text' },
  { name: 'grupoOrden', label: 'Orden del grupo', type: 'number', min: 0 },
  { name: 'orden', label: 'Orden', type: 'number', min: 0 },
  {
    name: 'severidad',
    label: 'Severidad',
    type: 'select',
    required: true,
    options: [
      { value: 'Rojo', label: 'Rojo' },
      { value: 'Amarillo', label: 'Amarillo' },
    ],
  },
  {
    name: 'fuente',
    label: 'Fuente',
    type: 'select',
    required: true,
    options: [
      { value: 'ReinfoLocal', label: 'REINFO Local' },
      { value: 'SunatScraping', label: 'SUNAT Scraping' },
      { value: 'RecpoLocal', label: 'RECPO Local' },
      { value: 'BaseDatosInterna', label: 'Base de Datos Interna' },
      { value: 'Manual', label: 'Manual' },
      { value: 'PostGIS', label: 'PostGIS' },
    ],
  },
  { name: 'umbralDias', label: 'Umbral (días)', type: 'number', min: 0 },
  { name: 'umbralPorcentaje', label: 'Umbral (%)', type: 'number', step: 0.01 },
  { name: 'activa', label: '¿Activa?', type: 'checkbox' },
  { name: 'aplicaPN', label: '¿Aplica a Persona Natural?', type: 'checkbox' },
  { name: 'aplicaPJ', label: '¿Aplica a Persona Jurídica?', type: 'checkbox' },
]

export default function ValidacionesRecepcionPage() {
  return (
    <CatalogoBasePage<ValidationConfigurationItem>
      title="Validaciones de Recepción"
      subtitle="Gestiona las reglas de validación aplicadas en recepción de mineral"
      entityName="validación"
      service={validacionesRecepcionCatalogService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(v) => v.id}
      idExtractor={(v) => v.id}
      searchPlaceholder="Buscar por código, nombre o grupo..."
      defaultValues={{
        activa: true,
        aplicaPN: true,
        aplicaPJ: true,
        severidad: 'Amarillo',
        fuente: 'Manual',
        grupoOrden: 0,
        orden: 0,
      }}
      modalSize="lg"
      createPermission="masters.write"
      updatePermission="masters.write"
      deletePermission="masters.write"
    />
  )
}
